import ResponsiveImage from './ResponsiveImage'

export default function ContentImage({ image, fallback = 'piloteadora-cielo', alt, className = '', sizes = '100vw', eager = false }) {
  if (!image?.key) {
    return <ResponsiveImage name={fallback} alt={alt || 'Equipo CRS trabajando en cimentación profunda'} className={className} sizes={sizes} eager={eager} />
  }

  const srcSet = (extension) => [720, 1440]
    .map((width) => `/images/wp/${image.key}-${width}.${extension} ${width}w`)
    .join(', ')

  return (
    <picture className={className}>
      <source type="image/webp" srcSet={srcSet('webp')} sizes={sizes} />
      <img
        src={`/images/wp/${image.key}-720.webp`}
        alt={alt || image.alt}
        width={image.width}
        height={image.height}
        loading={eager ? 'eager' : 'lazy'}
        fetchPriority={eager ? 'high' : 'auto'}
        decoding="async"
      />
    </picture>
  )
}
